import client from './client';
export const getDashboardStats   = ()          => client.get('/admin/dashboard');
export const getAllUsers          = ()          => client.get('/admin/users');
export const getUserById          = (id)        => client.get(`/admin/users/${id}`);
export const createUser           = (data)      => client.post('/admin/users', data);
export const updateUser           = (id, data)  => client.put(`/admin/users/${id}`, data);
export const updateUserSettings   = (id, data)  => client.put(`/admin/users/${id}/settings`, data);
export const resetUserPassword    = (id, data)  => client.put(`/admin/users/${id}/reset-password`, data);
export const toggleUserActive     = (id)        => client.put(`/admin/users/${id}/toggle-active`);
export const updateUserControl    = (id, data)  => client.put(`/admin/users/${id}/control`, data);
export const getAllBilling         = ()          => client.get('/billing');
export const getUserBilling        = (userId)   => client.get(`/billing/user/${userId}`);
export const generateInvoice       = (data)     => client.post('/billing/generate', data);
export const updateInvoiceStatus   = (id, s)    => client.put(`/billing/${id}/status`, { status: s });
export const getAllDeletionRequests = (status)  => client.get('/deletion-requests', { params: { status } });
export const resolveDeletionRequest = (id, d)  => client.put(`/deletion-requests/${id}/resolve`, d);
